import { Login } from "../../pages/login/login-interface";
import { BASE_URL } from "../../shared/utils/variables";

const baseURL = BASE_URL;

export const fetchLogin = async ({ email, password }: Login) => {
    const body = { email, password };
    
    const options = {
        method: 'POST',
        body: JSON.stringify(body),
        headers: { "Content-Type": "application/json" }
    };  

    try {
        const response: any = await fetch(`${baseURL}/login`, options);
        const data = await response.json();

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || `Erro HTTP ${response.status}`);
        }

        return data;
    } catch (error) {
        throw new Error(`Email ou senha inválidos: ${error}`);
    }
}